import React from 'react';

import { PostHogProvider } from 'posthog-js/react';
import { createRoot } from 'react-dom/client';

import { POSTHOG_HOST, POSTHOG_KEY } from '@/constants/env';
import { initializePostHog } from '@/services/posthog';

import App from './App';
import './index.css';

const root = createRoot(document.getElementById('root')!);
const strictMode = import.meta.env.DEV && import.meta.env.VITE_DISABLE_STRICT_MODE !== 'true';
const app = strictMode ? (
  <React.StrictMode>
    <App />
  </React.StrictMode>
) : (
  <App />
);

const renderApp = () => {
  const hash = window.location.hash;
  let bootstrap = undefined;

  if (hash && hash.length > 1) {
    const params = new URLSearchParams(hash.substring(1));
    const distinctID = params.get('distinct_id');
    const sessionID = params.get('session_id');

    // Only set bootstrap if at least one ID is present
    if (distinctID || sessionID) {
      bootstrap = {
        ...(distinctID && { distinctID }),
        ...(sessionID && { sessionID })
      };
    }
  }

  if (POSTHOG_KEY && POSTHOG_HOST) {
    const posthogClient = initializePostHog(bootstrap ? { bootstrap } : {});

    if (posthogClient) {
      root.render(<PostHogProvider client={posthogClient}>{app}</PostHogProvider>);
    } else {
      root.render(app);
    }
  } else {
    root.render(app);
  }
};

if (import.meta.env.DEV) {
  const { scan } = await import('react-scan');
  scan({
    enabled: true
  });

  const isMswEnabled = import.meta.env.VITE_ENABLE_MSW?.toLowerCase() === 'true';

  if (isMswEnabled) {
    const { worker } = await import('../mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  }

  renderApp();
} else {
  renderApp();
}
